import axios from "axios";

export default {
  name: "wishlistListSection",
  data() {
    return {
      friendList: [],
    };
  },
  async created() {
    var userId = {
      userId: window.localStorage.getItem("Giftstore-U"),
    };
    axios
      .post(
        "https://giftstore-blog.herokuapp.com/api/user/friend/getFriendList",
        userId
      )
      .then((response) => {
        console.log("1478526ô", response);
        this.friendList = response.data.friendList;
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  },
  methods: {
    UserName(firstName, lastName) {
      return firstName + " " + lastName;
    },
    linkFriend(id) {
      return "/wishlist-friend?idActive=" + id;
    },
    activeUserId() {
      this.$store.commit("setActiveUser", this.$route.query.idActive);
    },
  },
};
